<div #listContainer>
  @if (products.length > 0) {
    <div class="products-list-headers">
      @if (isDesktop) {
        <div>{{ 'habaProductConsultant.product' | cxTranslate }}</div>
        <div>{{ 'habaProductConsultant.description' | cxTranslate }}</div>
        <div>{{ 'habaProductConsultant.price' | cxTranslate }}</div>
        <div>{{ 'habaProductConsultant.actions' | cxTranslate }}</div>
      } @else {
        <div>{{ 'habaProductConsultant.suggestions' | cxTranslate }}</div>
      }
    </div>

    <div class="products-list">
      @for (product of products; track product.code) {
        <app-product-advisor-card [product]="product"></app-product-advisor-card>
      }
    </div>

    <!-- Hidden for now -->
    <!-- <div class="products-list-footer">
    <p>
      {{ 'habaProductConsultant.totalPriceText' | cxTranslate }}
      <span>{{ totalPrice | habaCurrency: products[0].currencyIso }}</span>
    </p>
    @if (noConfigurableProducts) {
      <button
        class="btn btn-add-to-cart"
        [disabled]="addToCartDisabled"
        type="button"
        (click)="addEntriesToCart()"
        [attr.data-qa]="addToCartButtonQaId?.getButtonId()"
      >
        {{ 'habaProductDetails.addToCart' | cxTranslate }}
      </button>
    }
  </div> -->
  }
</div>
